import { GlobalArea } from '@libs/templates/global-area';
import { ErrorBoundary } from '@libs/templates/template-pages';
import { Outlet, Route } from 'react-router';

export const userRouter = (
  <Route
    path="/user"
    element={
      <>
        <GlobalArea isUnderSubsystem={false} />
        <Outlet />
      </>
    }
    errorElement={<ErrorBoundary isUnderSubsystem={false} />}
  >
    <Route path="/user/change-password" lazy={async () => import('./pages/ChangePassword')} />
    <Route path="/user/mfa-setting/*" lazy={async () => import('./pages/MfaSettingIndex')} />
    <Route path="/user/webhook-token/*" lazy={async () => import('./pages/WebhookTokenIndex')} />
  </Route>
);
